import { useMedia } from 'react-use';
import { Box, ToggleCard } from '@zillow/constellation-10';
import { LoadingHeading, LoadingParagraph, LoadingTag, shimmerStyles } from '@zg-rentals/loading-components';

// Mirrors Panda's `breakpoints.md`. Inlined to avoid pulling `token()` into the bundle.
const MD_BREAKPOINT = '30em';

export const TourAvailabilityWizardSkeleton = () => {
  const isScreenMobile = useMedia(`(max-width: ${MD_BREAKPOINT})`);

  return (
    <>
      <Box
        css={{
          gridColumnStart: { base: '2', md: '4' },
          gridColumnEnd: { base: 'span 22', md: 'span 10' },
          marginTop: { md: 'tighter' },
        }}
      >
        <LoadingHeading isLoading={true} level={4} fontFamily="heading-alt" css={{ marginBottom: 'tighter' }}>
          &nbsp;
        </LoadingHeading>
        <LoadingParagraph isLoading={true} loadingWidth="90%" css={{ marginBottom: { base: 'loose', md: 40 } }}>
          &nbsp;
        </LoadingParagraph>
      </Box>
      <Box css={{ gridColumnStart: { base: '2', md: '4' }, gridColumnEnd: { base: 'span 22', md: 'span 18' } }}>
        <Box
          css={{ display: 'flex', flexDirection: { base: 'column', md: 'row' }, gap: { base: 'default', md: 'loose' } }}
        >
          {Array.from({ length: 2 }).map((_, index) => (
            <ToggleCard css={{ maxWidth: { lg: '290px' } }} key={`skeleton-card-${index}`} disabled={true}>
              {isScreenMobile ? (
                // Horizontal layout for mobile
                <Box css={{ display: 'flex', flexDirection: 'row', gap: 'sm' }}>
                  <Box
                    css={{ width: 'icon.md', height: 'icon.md', borderRadius: 'sm', ...shimmerStyles }}
                    data-loading={true}
                  />

                  <Box css={{ display: 'flex', flexDirection: 'column', gap: 'xs', flex: 1 }}>
                    <Box css={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                      <LoadingHeading isLoading={true} level={6} loadingWidth="150px">
                        &nbsp;
                      </LoadingHeading>
                      <LoadingTag isLoading={true} size="sm" loadingWidth="100px">
                        &nbsp;
                      </LoadingTag>
                    </Box>
                    <Box>
                      <LoadingParagraph isLoading={true} textStyle="body-sm" loadingWidth="250px">
                        &nbsp;
                      </LoadingParagraph>
                      <LoadingParagraph isLoading={true} textStyle="body-sm" loadingWidth="250px">
                        &nbsp;
                      </LoadingParagraph>
                    </Box>
                  </Box>
                </Box>
              ) : (
                // Vertical layout for desktop
                <Box
                  css={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    gap: 'md',
                    marginTop: 'xs',
                    marginBottom: 'lg',
                  }}
                >
                  <Box
                    css={{ width: 'icon.lg', height: 'icon.lg', borderRadius: 'sm', ...shimmerStyles }}
                    data-loading={true}
                  />

                  <Box css={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 'sm' }}>
                    <LoadingHeading isLoading={true} level={5} loadingWidth="150px">
                      &nbsp;
                    </LoadingHeading>
                    <LoadingTag isLoading={true} loadingWidth="100px">
                      &nbsp;
                    </LoadingTag>
                  </Box>
                  <Box>
                    <LoadingParagraph
                      isLoading={true}
                      textStyle="body-sm"
                      loadingWidth="250px"
                      css={{ marginLeft: 'tighter', marginRight: 'tighter', textAlign: 'center' }}
                    >
                      &nbsp;
                    </LoadingParagraph>
                    <LoadingParagraph
                      isLoading={true}
                      textStyle="body-sm"
                      loadingWidth="250px"
                      css={{ marginLeft: 'tighter', marginRight: 'tighter', textAlign: 'center' }}
                    >
                      &nbsp;
                    </LoadingParagraph>
                  </Box>
                </Box>
              )}
            </ToggleCard>
          ))}
        </Box>
      </Box>
    </>
  );
};
